import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Static UI translations are BUNDLED into the JS (not fetched at runtime) so they render
// instantly with no flash of raw keys — important for SEO/crawlers and reliable in production
// regardless of static-file serving.
import en from './locales/en.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import es from './locales/es.json';

// Supported languages. English is the default and has NO URL prefix.
// Other languages use a path prefix, e.g. /de/events, /fr/events, /es/events
export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'de', label: 'Deutsch', short: 'DE' },
  { code: 'fr', label: 'Français', short: 'FR' },
  { code: 'es', label: 'Español', short: 'ES' },
];

export const LANG_CODES = SUPPORTED_LANGUAGES.map((l) => l.code);
export const DEFAULT_LANG = 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      fr: { translation: fr },
      es: { translation: es },
    },
    lng: DEFAULT_LANG,
    fallbackLng: DEFAULT_LANG,
    supportedLngs: LANG_CODES,
    ns: ['translation'],
    defaultNS: 'translation',
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
